import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppButton } from '@pro-sto/ui';
import { ROUTES } from '@/constants/routes';
import './NotFound.css';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found" data-testid="not-found-page">
      <h1 className="not-found__title">404</h1>
      <p className="not-found__text">Страница не найдена</p>
      <div className="not-found__action">
        <AppButton variant="primary" size="M" onClick={() => navigate(ROUTES.DASHBOARD)}>
          На главную
        </AppButton>
      </div>
    </div>
  );
};

export default NotFound;
